/* Kailar Neubau D · gemeinsames Verhalten (Quelle: showcase _assets-d/src/kd.js, finder.js, bew.js).
   Regel D: Rückmeldungen nur über Text, Farbe und Deckkraft. Nichts springt, nichts bewegt sich.

   Konventionen für alle Abschnitte (auch Produktseite und Warenkorb):
   - Schubladen: <section class="kd-sheet" id="kd-xyz" data-kd-sheet> irgendwo im Abschnitt; KD hängt sie beim Start
     in #kd-layer um. Öffnen mit [data-open="kd-xyz"], schließen mit [data-close], Scrim oder Escape. Per JS: KD.open(id).
   - Umschalter: Container [data-kd-switch], Knöpfe [data-kd-show="key"], Flächen [data-kd-pane="key"].
     Knöpfe mit role="radio" bekommen aria-checked, sonst aria-pressed. Mit data-kd-fade am Container wechseln die
     Flächen über .is-on/aria-hidden (liegen übereinander), sonst über hidden.
   - In die Tüte: <button data-kd-add="VARIANT_ID" [data-kd-qty="1"]> mit .kd-btn__label/.kd-btn__done/.kd-btn__err.
     Ereignisse auf document: kd:cart-added {item, cart, button}, kd:cart-error {message, button}.
   - Kaufleiste: Element mit [data-kd-dock] (z. B. .kd-bar) wandert ins Dock vor die 5-€-Lasche.
   - Tüte: Kopf-Knopf [data-kd-cart-open] ist ein Link auf /cart. Gibt es #kd-cart (Warenkorb-Schublade), öffnet KD sie
     statt zu navigieren und sendet kd:cart-open.
   - Code kopieren: [data-copy="CODE"]. Lightbox: KD.lightbox([urls], index). */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const cfg = window.KD_CFG || {};
  const T = cfg.t || {};
  const emit = (el, name, detail) => el.dispatchEvent(new CustomEvent(name, { bubbles: true, detail }));
  const iconTpl = (name) => {
    const t = document.getElementById('kd-icon-' + name);
    return t ? t.innerHTML : '';
  };

  /* ---------- Schubladen (nur Ein-/Ausblenden) ----------
     Eine gemeinsame Fokus-Leitplanke für alle Schubladen und Fenster (Menü, Tüte, 5 €, Bewertung, Lightbox):
     Öffnen setzt den Fokus hinein ([data-autofocus], sonst Schließen-Knopf), Seite und Dock werden inert,
     Tab bleibt drin, Escape schließt, der Fokus geht an den Auslöser zurück. Auslöser [data-open] bekommen aria-expanded. */
  let lastFocus = null;
  const OPEN_SEL = '.kd-sheet.is-on, .kd-lightbox.is-on';
  const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';
  const focusables = (box) => $$(FOCUSABLE, box).filter((el) => el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden' && !el.closest('[inert], [aria-hidden="true"]'));
  /* Hintergrund für Tastatur und Screenreader stilllegen, solange ein Fenster offen ist */
  function backdrop(on) {
    [$('.kd-app'), $('.kd-dock')].forEach((el) => { if (el) el.inert = on; });
  }
  function triggers(id, on) {
    $$(`[data-open="${CSS.escape(id)}"]`).forEach((b) => b.setAttribute('aria-expanded', String(on)));
  }
  function moveSheets(root = document) {
    const layer = $('#kd-layer'); if (!layer) return;
    const before = $('#kd-lightbox', layer);
    const dock = $('.kd-dock', layer); const tab = $('#kd-lasche', layer);
    $$('[data-kd-dock]', root).forEach((b) => {
      if (b.parentElement === dock) return;
      const old = b.id && dock.querySelector(`#${CSS.escape(b.id)}`);
      if (old && old !== b) old.remove();
      dock.insertBefore(b, tab);
    });
    $$('[data-kd-sheet]', root).forEach((s) => {
      if (s.parentElement === layer) return;
      const old = s.id && layer.querySelector(`#${CSS.escape(s.id)}`);
      if (old && old !== s) old.remove();
      layer.insertBefore(s, before || null);
    });
  }
  function open(id) {
    const el = document.getElementById(id); if (!el) return;
    /* Wechsel von Fenster zu Fenster (z. B. Empfehlung in der Tüte): der ursprüngliche Auslöser bleibt das Ziel */
    const was = $(OPEN_SEL);
    const act = document.activeElement;
    if (!was || !was.contains(act)) lastFocus = act && act !== document.body ? act : null;
    closeAll(true);
    el.classList.add('is-on'); document.body.classList.add('kd-sheet-open');
    if (!el.classList.contains('kd-lightbox')) $('#kd-scrim')?.classList.add('is-on');
    if (el.getAttribute('role') === 'dialog') el.setAttribute('aria-modal', 'true');
    backdrop(true); triggers(id, true);
    setTimeout(() => {
      if (!el.classList.contains('is-on') || el.contains(document.activeElement)) return;
      const f = el.querySelector('[data-autofocus]') || el.querySelector('[data-close]') || focusables(el)[0];
      if (f) f.focus({ preventScroll: true });
      else { el.tabIndex = -1; el.focus({ preventScroll: true }); }
    }, 30);
    emit(el, 'kd-open', {});
  }
  function closeAll(silent) {
    const on = $$(OPEN_SEL);
    on.forEach((s) => { s.classList.remove('is-on'); if (s.id) triggers(s.id, false); });
    $('#kd-scrim')?.classList.remove('is-on'); document.body.classList.remove('kd-sheet-open');
    backdrop(false);
    if (silent || !on.length) return;
    const back = lastFocus && lastFocus.isConnected && lastFocus.getClientRects().length ? lastFocus : $('#MainContent');
    back?.focus({ preventScroll: true });
  }
  /* Tab und Umschalt+Tab kreisen im offenen Fenster */
  function trap(e) {
    const box = $(OPEN_SEL); if (!box) return;
    const f = focusables(box); if (!f.length) { e.preventDefault(); return; }
    const first = f[0]; const last = f[f.length - 1]; const act = document.activeElement;
    if (!box.contains(act)) { e.preventDefault(); (e.shiftKey ? last : first).focus(); return; }
    if (e.shiftKey && (act === first || act === box)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && act === last) { e.preventDefault(); first.focus(); }
  }

  /* ---------- Statuszeile (#kd-status, role=status) für Ansagen ohne sichtbare Änderung ---------- */
  function say(text) {
    const box = $('#kd-status'); if (!box || !text) return;
    box.textContent = '';
    setTimeout(() => { box.textContent = text; }, 60);
  }
  const money = (cents, cur) => {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'de', { style: 'currency', currency: cur || 'EUR' }).format((cents || 0) / 100); } catch (e) { return ''; }
  };
  /* Vorlage mit [title], [n], [total] aus KD_CFG.t */
  function cartSay(tpl, title, cart) {
    if (!tpl || !cart) return;
    say(tpl.replace('[title]', title || '').replace('[n]', String(cart.item_count || 0)).replace('[total]', money(cart.total_price, cart.currency)));
  }

  /* ---------- Dock-Höhe (Lasche + Kaufleiste) als --kd-dock-h: Scroll-Abstand für Fokus, Platz für das hCaptcha-Abzeichen ---------- */
  function dockWatch() {
    const dock = $('.kd-dock'); if (!dock) return;
    const set = () => document.documentElement.style.setProperty('--kd-dock-h', Math.ceil(dock.getBoundingClientRect().height) + 'px');
    set();
    if ('ResizeObserver' in window) new ResizeObserver(set).observe(dock);
    /* Fallback, falls der Browser scroll-padding beim Tabben nicht beachtet: Fokus über Dock und Abzeichen schieben */
    document.addEventListener('focusin', (e) => {
      const t = e.target; if (!t || !t.matches || !t.matches(':focus-visible') || dock.contains(t) || t.closest('#kd-layer, #shop-hcaptcha-badge-container, #shopify-pc__banner')) return;
      const r = t.getBoundingClientRect(); const limit = innerHeight - dock.getBoundingClientRect().height - 12;
      if (r.bottom > limit && r.top > 0) scrollBy(0, Math.min(r.bottom - limit, r.top - 90));
    });
  }
  function lightbox(list, i) {
    const lb = $('#kd-lightbox'); if (!lb || !list.length) return;
    const img = $('img', lb); const count = $('[data-lb-count]', lb);
    const show = () => { img.src = list[i]; count.textContent = `${i + 1} / ${list.length}`; };
    lb.kdPrev = () => { i = (i - 1 + list.length) % list.length; show(); };
    lb.kdNext = () => { i = (i + 1) % list.length; show(); };
    show(); open('kd-lightbox');
  }

  /* ---------- Umschalter ---------- */
  function show(btn) {
    const box = btn.closest('[data-kd-switch]'); if (!box || btn.disabled) return;
    const key = btn.dataset.kdShow;
    const own = (el) => el.closest('[data-kd-switch]') === box;
    $$('[data-kd-show]', box).filter(own).forEach((b) => {
      b.setAttribute(b.getAttribute('role') === 'radio' ? 'aria-checked' : 'aria-pressed', String(b === btn));
    });
    const fade = 'kdFade' in box.dataset;
    $$('[data-kd-pane]', box).filter(own).forEach((p) => {
      const on = p.dataset.kdPane === key;
      if (fade) { p.classList.toggle('is-on', on); p.setAttribute('aria-hidden', String(!on)); } else p.hidden = !on;
    });
    emit(box, 'kd-change', { value: key, btn });
  }

  /* ---------- Tüte (Shopify AJAX) ---------- */
  const root = (cfg.routes && cfg.routes.root) || '/';
  const url = (p) => (root.endsWith('/') ? root : root + '/') + p;
  async function cartRefresh() {
    try {
      const r = await fetch(url('cart.js'), { headers: { Accept: 'application/json' } });
      const cart = await r.json();
      $$('[data-bag-n]').forEach((el) => { el.textContent = cart.item_count ? String(cart.item_count) : ''; });
      emit(document, 'kd:cart-updated', { cart });
      return cart;
    } catch (e) { return null; }
  }
  async function cartAdd(id, qty = 1, properties) {
    const item = { id: Number(id), quantity: Number(qty) || 1 };
    if (properties) item.properties = properties;
    const r = await fetch(url('cart/add.js'), {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item] }),
    });
    const data = await r.json().catch(() => ({}));
    if (!r.ok) { const err = new Error(data.description || data.message || T.cartError || 'Error'); err.data = data; throw err; }
    const cart = await cartRefresh();
    return { item: (data.items && data.items[0]) || data, cart };
  }
  const flash = (b, cls) => { b.classList.add(cls); clearTimeout(b.kdT); b.kdT = setTimeout(() => b.classList.remove(cls), cls === 'is-err' ? 3200 : 2200); };
  async function addButton(b) {
    if (b.classList.contains('is-busy')) return;
    b.classList.remove('is-done', 'is-err'); b.classList.add('is-busy'); b.setAttribute('aria-busy', 'true');
    try {
      /* Probe-Knopf (Lea 07.10.): der Freundescode wird mit dem Hinzufügen eingelöst, ohne eigenen Tipp. Scheitert der Code, kommt die Probe trotzdem in die Tüte. */
      if (b.dataset.kdCode) await codeApply(b.dataset.kdCode).catch(() => {});
      const res = await cartAdd(b.dataset.kdAdd, b.dataset.kdQty || 1);
      flash(b, 'is-done');
      emit(document, 'kd:cart-added', { ...res, button: b });
    } catch (e) {
      const m = b.querySelector('.kd-btn__err span'); if (m && e.message) m.textContent = e.message;
      flash(b, 'is-err');
      emit(document, 'kd:cart-error', { message: e.message, button: b });
    } finally { b.classList.remove('is-busy'); b.removeAttribute('aria-busy'); }
  }

  /* ---------- 5-€-Lasche und Anmeldung (Shopify Kundenformular, Double-Opt-in) ---------- */
  const NEWS_KEY = 'kd-news';
  function lascheDone() {
    const tab = $('#kd-lasche'); if (!tab) return;
    tab.classList.add('is-done');
    const txt = $('.kd-lasche__text', tab);
    if (txt && T.lascheFertig) txt.innerHTML = `${T.lascheFertig}<small>${T.lascheFertigKlein}</small>`;
  }
  /* X: Lasche 14 Tage ausblenden ('used' = für immer, nach dem Einlösen). Fokus geht an den Seiteninhalt, die Statuszeile sagt es an. */
  const OFF_KEY = 'kd-lasche-off';
  const OFF_DAYS = 14;
  function lascheOff(forever) {
    try { localStorage.setItem(OFF_KEY, forever ? 'used' : String(Date.now() + OFF_DAYS * 864e5)); } catch (e) { /* privat */ }
    document.documentElement.classList.add('kd-lasche-off');
  }
  /* Good Repeats (Feld „Good Repeats signup address“, layout/theme.liquid). Nur eine Adresse genau https://<host>/s/<uuid>
     zählt, Leerzeichen am Rand und Großbuchstaben werden vorher bereinigt; leer oder anders = Shopify-Kundenformular wie
     bisher. Lasche und Fenster schicken dann form-encoded ohne Cookies an den Motor (einfache CORS-Anfrage). Die Antwort ist für neue, wartende und bestätigte Adressen gleich (202). */
  const NEWS_ENGINE = (() => {
    const v = typeof window.kailarNewsletterEngine === 'string' ? window.kailarNewsletterEngine.trim().toLowerCase() : '';
    return /^https:\/\/[^/\s?#]+\/s\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/.test(v) ? v : '';
  })();
  /* Unsichtbares Feld gegen Bots, nur auf dem Motor-Weg (ausgefüllt = Motor nimmt still an und tut nichts).
     data-nocaptcha: Shopifys hCaptcha hängt sich sonst beim ersten Fokus an das Kundenformular und schickt es nach dem
     Lösen doch an /contact (Shopify-Kunde mit Newsletter-Tag). Der Motor schützt sich selbst (dieses Feld, Ratenlimit). */
  function newsTrap(form) {
    if (!form || $('input[name="website"]', form)) return;
    form.setAttribute('data-nocaptcha', 'true');
    const t = document.createElement('input');
    Object.assign(t, { type: 'text', name: 'website', tabIndex: -1, autocomplete: 'off', className: 'kd-sr' });
    t.setAttribute('aria-hidden', 'true');
    form.appendChild(t);
  }
  /* Fertig-Zustand wie nach Shopifys posted_successfully (gleiche Klassen und Texte), im Fenster mit Überschrift.
     „Andere E-Mail-Adresse eingeben“ holt dieselben Formularknoten zurück (Listener hängen am form und an den Feldern),
     Feld leer, Häkchen wie vorher. Lasche und kd-news bleiben auf „Fast geschafft“: die erste Adresse ist angemeldet. */
  function newsDoneView(form, pop) {
    const NT = window.KD_NEWS_T || {};
    const el = (tag, cls, text) => { const n = document.createElement(tag); n.className = cls; n.textContent = text || ''; return n; };
    const stack = el('div', 'kd-stack');
    const title = el(pop ? 'h2' : 'p', pop ? 'kd-h2' : 'kd-h3', NT.doneTitle);
    const text = el('p', 'kd-body kd-mute', NT.doneText);
    if (pop) { title.id = 'kd-pop-title'; title.tabIndex = -1; text.id = 'kd-pop-intro'; }
    const more = el('button', 'kd-btn kd-btn--line kd-btn--wide', NT.weiter);
    more.type = 'button'; more.setAttribute('data-close', '');
    stack.append(title, text, more);
    const kids = [...form.childNodes];
    if (NT.andereAdresse) {
      const other = el('button', 'kd-link kd-news__other', NT.andereAdresse);
      other.type = 'button';
      other.addEventListener('click', () => newsFormBack(form, kids));
      stack.append(other);
    }
    form.replaceChildren(stack);
    (pop ? title : more).focus({ preventScroll: true });
  }
  function newsFormBack(form, kids) {
    form.replaceChildren(...kids);
    form.removeAttribute('aria-busy');
    const btn = $('button[type="submit"]', form); if (btn) btn.disabled = false;
    $$('.kd-field', form).forEach((f) => {
      f.classList.remove('is-err', 'is-ok');
      const m = $('.kd-field__msg', f);
      if (m && $('input[type="email"]', f)) m.innerHTML = `<span>${T.newsAbmelden || ''}</span>`;
      else if (m) m.hidden = true;
    });
    const mail = $('input[type="email"]', form);
    if (mail) { mail.value = ''; mail.focus(); }
  }
  /* Absenden an den Motor; Prüfung von E-Mail und Häkchen ist vorher schon gelaufen. 202 = fertig, 400 = Adresse
     ungültig, alles andere (auch Netz) = allgemeiner Fehler, Eingabe bleibt stehen. */
  function newsSend(form, source) {
    if (!NEWS_ENGINE || form.getAttribute('aria-busy') === 'true') return;
    const mail = $('input[type="email"]', form); const field = mail.closest('.kd-field'); const msg = $('.kd-field__msg', field);
    const btn = $('button[type="submit"]', form);
    form.setAttribute('aria-busy', 'true'); if (btn) btn.disabled = true;
    const body = new URLSearchParams();
    body.set('email', (mail.value || '').trim());
    body.set('website', ($('input[name="website"]', form) || {}).value || '');
    body.set('source', source);
    fetch(NEWS_ENGINE, { method: 'POST', credentials: 'omit', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: body.toString() })
      .then((r) => {
        if (r.status !== 202 && r.status !== 200) throw new Error(r.status === 400 ? 'invalid' : 'status ' + r.status);
        try { localStorage.setItem(NEWS_KEY, '1'); } catch (e) { /* privat */ }
        lascheDone();
        newsDoneView(form, source === 'Popup');
      })
      .catch((e) => {
        field.classList.add('is-err'); field.classList.remove('is-ok');
        const text = e && e.message === 'invalid' ? (window.KD_NEWS_T || {}).ungueltig : T.cartError;
        msg.innerHTML = iconTpl('warning-circle') + `<span>${text || ''}</span>`;
        if (btn) btn.disabled = false;
        mail.focus();
      })
      .finally(() => form.removeAttribute('aria-busy'));
  }
  function newsInit() {
    const tab = $('#kd-lasche');
    const x = $('#kd-lasche-x');
    x?.addEventListener('click', () => {
      lascheOff(false);
      $('#MainContent')?.focus({ preventScroll: true });
      say(x.dataset.said);
    });
    let saved = null; try { saved = localStorage.getItem(NEWS_KEY); } catch (e) { /* privat */ }
    if (saved) lascheDone();
    tab?.addEventListener('click', () => {
      /* Klaviyo-Formular nur, wenn eingestellt UND klaviyo.js nach Einwilligung wirklich geladen ist; Good Repeats gewinnt */
      const kl = tab.dataset.klaviyoForm;
      if (kl && !NEWS_ENGINE && $('script[data-kailar-consent-gated="true"]')) { (window._klOnsite = window._klOnsite || []).push(['openForm', kl]); return; }
      open('kd-news');
    });
    const sheet = $('#kd-news'); if (!sheet) return;
    const state = $('[data-kd-news-state]', sheet)?.dataset.kdNewsState;
    if (state === 'done') {
      try { localStorage.setItem(NEWS_KEY, '1'); } catch (e) { /* privat */ }
      lascheDone(); open('kd-news');
    } else if (state === 'error') open('kd-news');
    const form = $('form', sheet); if (!form) return;
    const mail = $('input[type="email"]', form); const field = mail?.closest('.kd-field'); const msg = field && $('.kd-field__msg', field);
    const haken = $('[data-kd-news-ok]', form); const hField = haken?.closest('.kd-field'); const hMsg = hField && $('.kd-field__msg', hField);
    const warn = (el, text) => { el.innerHTML = iconTpl('warning-circle') + `<span>${text}</span>`; };
    form.addEventListener('submit', (e) => {
      const ok = /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test((mail.value || '').trim());
      field.classList.toggle('is-err', !ok); field.classList.toggle('is-ok', ok);
      if (!ok) { e.preventDefault(); warn(msg, T.newsMailFehlt); mail.focus(); return; }
      /* Einwilligung: Häkchen ist Pflicht und nie vorausgewählt */
      if (haken && !haken.checked) { e.preventDefault(); hField.classList.add('is-err'); warn(hMsg, T.newsHakenFehlt); hMsg.hidden = false; haken.focus(); return; }
      /* Good Repeats statt Shopify-Kundenformular, nur wenn das Feld gesetzt ist */
      if (NEWS_ENGINE) { e.preventDefault(); newsSend(form, 'Lasche'); }
    });
    if (NEWS_ENGINE) newsTrap(form);
    mail?.addEventListener('input', () => { if (field.classList.contains('is-err')) { field.classList.remove('is-err'); msg.innerHTML = `<span>${T.newsAbmelden}</span>`; } });
    haken?.addEventListener('change', () => { if (haken.checked) { hField.classList.remove('is-err'); hMsg.hidden = true; } });
  }

  /* ---------- Code kopieren ---------- */
  function copy(b) {
    if (!b.kdLabel) b.kdLabel = b.innerHTML;
    navigator.clipboard?.writeText(b.dataset.copy).catch(() => {});
    b.innerHTML = iconTpl('check') + (T.kopiert || 'OK'); clearTimeout(b.kdT);
    b.kdT = setTimeout(() => { b.innerHTML = b.kdLabel; }, 2000);
  }

  /* ---------- Code mit einem Tipp einlösen: [data-kd-redeem="CODE"] ----------
     Hängt den Code an den Warenkorb (cart/update.js, vorhandene Codes bleiben), Shopify zieht ihn an der Kasse ab.
     Auch ohne passenden Artikel: der Code wartet im Korb und greift, sobald z. B. die Probe drin ist.
     Texte aus #kd-redeem-t (d-layer). Der Code bleibt daneben sichtbar zum Abtippen. */
  const RT = () => $('#kd-redeem-t')?.dataset || {};
  const sameCode = (a, b) => String(a).trim().toLowerCase() === String(b).trim().toLowerCase();
  function redeemMsg(b, text, err) {
    const box = b.closest('.kd-code') || b; let m = box.nextElementSibling;
    if (!m || !m.classList.contains('kd-code__msg')) { m = document.createElement('p'); m.className = 'kd-code__msg'; m.setAttribute('role', 'status'); box.after(m); }
    m.classList.toggle('is-err', !!err); m.innerHTML = iconTpl(err ? 'warning-circle' : 'check') + `<span>${text || ''}</span>`;
  }
  function redeemDone(b) {
    b.classList.add('is-done'); b.innerHTML = iconTpl('check') + (RT().done || 'OK');
    redeemMsg(b, RT().msg);
  }
  async function codeApply(code) {
    const cart = await fetch(url('cart.js'), { headers: { Accept: 'application/json' } }).then((r) => r.json());
    const have = (cart.discount_codes || []).map((c) => c.code);
    let data = cart;
    if (!have.some((c) => sameCode(c, code))) {
      const r = await fetch(url('cart/update.js'), {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: [...have, code].join(',') }),
      });
      if (!r.ok) throw new Error('update');
      data = await r.json();
    }
    if (!(data.discount_codes || []).some((c) => sameCode(c.code, code))) throw new Error('code');
    $$('[data-kd-redeem]').filter((x) => sameCode(x.dataset.kdRedeem, code)).forEach(redeemDone);
  }
  async function redeem(b) {
    if (b.classList.contains('is-busy') || b.classList.contains('is-done')) return;
    const code = b.dataset.kdRedeem; b.classList.add('is-busy'); b.setAttribute('aria-busy', 'true');
    try {
      await codeApply(code);
      if (window.KC && window.KC.refresh) window.KC.refresh(); else cartRefresh();
    } catch (e) {
      redeemMsg(b, RT().err, true);
    } finally { b.classList.remove('is-busy'); b.removeAttribute('aria-busy'); }
  }
  /* Beim Laden: steckt der Code schon im Korb, steht der Knopf gleich auf „Eingelöst“ */
  async function redeemInit() {
    const list = $$('[data-kd-redeem]'); if (!list.length) return;
    try {
      const cart = await fetch(url('cart.js'), { headers: { Accept: 'application/json' } }).then((r) => r.json());
      const have = (cart.discount_codes || []).map((c) => c.code);
      list.filter((b) => have.some((c) => sameCode(c, b.dataset.kdRedeem))).forEach(redeemDone);
    } catch (e) { /* bleibt einlösbar */ }
  }

  /* ---------- Bewertungen: „… mehr“ nur, wenn der Text wirklich abgeschnitten ist ---------- */
  function bewMark() {
    $$('.kb-row .kb-card').forEach((c) => { const t = $('.kb-text', c); const m = $('.kb-more', c); if (t && m) m.classList.toggle('is-on', t.scrollHeight > t.clientHeight + 2); });
  }
  function bewOpen(btn) {
    const card = btn.closest('.kb-card'); const body = $('#kd-bew [data-bew-body]'); if (!card || !body) return;
    const c = card.cloneNode(true); c.querySelector('.kb-more')?.remove(); c.removeAttribute('role');
    const link = $('#kd-bew template'); if (link) c.appendChild(link.content.cloneNode(true));
    body.replaceChildren(c); open('kd-bew');
  }

  /* ---------- Start ---------- */
  function init(scope = document) {
    moveSheets(scope);
    bewMark();
  }
  document.addEventListener('click', (e) => {
    const t = e.target;
    const sw = t.closest('[data-kd-show]'); if (sw) show(sw);
    if (t.closest('[data-close]') || t.id === 'kd-scrim') closeAll();
    const op = t.closest('[data-open]'); if (op) { e.preventDefault(); open(op.dataset.open); }
    const add = t.closest('[data-kd-add]'); if (add) { e.preventDefault(); addButton(add); }
    const cp = t.closest('[data-copy]'); if (cp) copy(cp);
    const rd = t.closest('[data-kd-redeem]'); if (rd) redeem(rd);
    const bag = t.closest('[data-kd-cart-open]');
    if (bag && document.getElementById('kd-cart')) { e.preventDefault(); open('kd-cart'); emit(document, 'kd:cart-open', {}); }
    const more = t.closest('[data-bew-more]'); if (more) bewOpen(more);
    if (t.closest('[data-lb-prev]')) $('#kd-lightbox').kdPrev?.();
    if (t.closest('[data-lb-next]')) $('#kd-lightbox').kdNext?.();
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAll(); else if (e.key === 'Tab') trap(e); });
  /* Theme-Editor: neu geladene Abschnitte wieder einhängen */
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  addEventListener('resize', () => requestAnimationFrame(bewMark));

  const start = () => { init(); newsInit(); dockWatch(); redeemInit(); if (document.fonts) document.fonts.ready.then(bewMark); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();

  /* Tüte: Ansage nach dem Hinzufügen (Produktseite, Kacheln, Probe) */
  document.addEventListener('kd:cart-added', (e) => {
    const d = e.detail || {}; const it = d.item || {};
    cartSay(T.cartAdded, it.product_title || it.title, d.cart);
  });

  window.KD = { open, closeAll, show, lightbox, cartAdd, cartRefresh, codeApply, moveSheets, lascheDone, lascheOff, say, cartSay, newsEngine: NEWS_ENGINE, newsSend, newsTrap };
})();
